import { getCenterFromBounds } from '../../../../util/location';

export const getCountryConfig = (listingType, country) => {
    const buildLink = ({ address, bounds }) => {
        const origin = getCenterFromBounds(bounds);
        return `?address=${address}&bounds=${bounds}&origin=${origin}&listingType=${listingType}`;
    };

    const ch_config = {
        primary: [
            {
                label: 'Zürich',
                backgroundUrl: 'https://horsedeal.imgix.net/static/landingPage/kanton-zuerich.webp',
                link: buildLink({
                    address: '8001%20Zürich%2C%20Schweiz',
                    bounds:
                        '47.43466497109218,8.625452857661037,47.32021840892072,8.448018098135877',
                }),
            },
            {
                label: 'Bern',
                backgroundUrl: 'https://horsedeal.imgix.net/static/landingPage/kanton-bern.webp',
                link: buildLink({
                    address: '3005%20Bern%2C%20Schweiz',
                    bounds:
                        '46.99015355011818,7.495557500753322,46.91903346990998,7.294313869775355',
                }),
            },
            {
                label: 'Luzern',
                backgroundUrl: 'https://horsedeal.imgix.net/static/landingPage/kanton-luzern.webp',
                link: buildLink({
                    address: '6003%20Luzern%2C%20Schweiz',
                    bounds:
                        '47.08352198497926,8.427985244519215,46.99800465423257,8.206519713261496',
                }),
            },
        ],
        secondary: [
            {
                label: 'Aargau',
                link: buildLink({
                    address: '5607%20Aargau%2C%20Schweiz',
                    bounds:
                        '47.62109914552563,8.455110820321586,47.13747826393558,7.713680989478767',
                }),
            },
            {
                label: 'Appenzell A. Rh.',
                link: buildLink({
                    address: '9050%20Appenzell%2C%20Schweiz',
                    bounds:
                        '47.36127213139374,9.479238119876204,47.30427014347277,9.371899858050934',
                }),
            },
            {
                label: 'Appenzell I.Rh.',
                link: buildLink({
                    address: '9050%20Appenzell%2C%20Schweiz',
                    bounds:
                        '47.36127213139374,9.479238119876204,47.30427014347277,9.371899858050934',
                }),
            },
            {
                label: 'Basel-Landschaft',
                link: buildLink({
                    address: '4434%20Basel-Landschaft%2C%20Schweiz',
                    bounds:
                        '47.56436505246851,7.961840155235254,47.33788436171407,7.325192230528097',
                }),
            },
            {
                label: 'Basel-Stadt',
                link: buildLink({
                    address: '4101%20Basel-Stadt%2C%20Schweiz',
                    bounds:
                        '47.60091597170511,7.693802995664923,47.51929722476486,7.554662174474645',
                }),
            },
            {
                label: 'Bern',
                link: buildLink({
                    address: '3005%20Bern%2C%20Schweiz',
                    bounds:
                        '46.99015355011818,7.495557500753322,46.91903346990998,7.294313869775355',
                }),
            },
            {
                label: 'Freiburg',
                link: buildLink({
                    address: '1700%20Freiburg%2C%20Schweiz',
                    bounds:
                        '46.82154351316485,7.183972353873282,46.78489411674873,7.135651865738429',
                }),
            },
            {
                label: 'Genf',
                link: buildLink({
                    address: '1204%20Genf%2C%20Schweiz',
                    bounds:
                        '46.23188590700985,6.175845331633314,46.17777408095893,6.110232376789464',
                }),
            },
            {
                label: 'Glarus',
                link: buildLink({
                    address: '8750%20Glarus%2C%20Schweiz',
                    bounds:
                        '47.08206413648321,9.13410840820931,46.96715916502913,8.892991539340821',
                }),
            },
            {
                label: 'Graubünden',
                link: buildLink({
                    address: '7450%20Graubünden%2C%20Schweiz',
                    bounds:
                        '47.06495997911451,10.49234009011136,46.1690499381677,8.651067214602177',
                }),
            },
            {
                label: 'Jura',
                link: buildLink({
                    address: '2884%20Jura%2C%20Schweiz',
                    bounds:
                        '47.50451996289815,7.558345726904528,47.15040917740119,6.840419998055427',
                }),
            },
            {
                label: 'Luzern',
                link: buildLink({
                    address: '6003%20Luzern%2C%20Schweiz',
                    bounds:
                        '47.08352198497926,8.427985244519215,46.99800465423257,8.206519713261496',
                }),
            },
            {
                label: 'Neuenburg',
                link: buildLink({
                    address: '2000%20Neuenburg%2C%20Schweiz',
                    bounds:
                        '47.06382621046629,6.991771642999991,46.97784155135839,6.845142035608892',
                }),
            },
            {
                label: 'Nidwalden',
                link: buildLink({
                    address: '6383%20Nidwalden%2C%20Schweiz',
                    bounds:
                        '47.01995369386434,8.574954495047482,46.77151393580548,8.218102176555993',
                }),
            },
            {
                label: 'Obwalden',
                link: buildLink({
                    address: '6073%20Obwalden%2C%20Schweiz',
                    bounds:
                        '46.98036374614514,8.506886041273226,46.75316900418883,8.042202040161737',
                }),
            },
            {
                label: 'Schaffhausen',
                link: buildLink({
                    address: '8208%20Schaffhausen%2C%20Schweiz',
                    bounds:
                        '47.7530971534953,8.705936230973828,47.68529986594775,8.541019600511015',
                }),
            },
            {
                label: 'Schwyz',
                link: buildLink({
                    address: '6441%20Schwyz%2C%20Schweiz',
                    bounds: '47.06641453913493,8.77890359793155,46.9851520611211,8.603230368591534',
                }),
            },
            {
                label: 'Solothurn',
                link: buildLink({
                    address: '4500%20Solothurn%2C%20Schweiz',
                    bounds:
                        '47.22022373920954,7.552309216767537,47.19594437196561,7.509311329089161',
                }),
            },
            {
                label: 'St. Gallen',
                link: buildLink({
                    address: '9000%20St.%20Gallen%2C%20Schweiz',
                    bounds: '47.453073334111,9.435247405394504,47.39515489622522,9.29151608528761',
                }),
            },
            {
                label: 'Tessin',
                link: buildLink({
                    address: '6635%20Tessin%2C%20Schweiz',
                    bounds:
                        '46.63248384244249,9.159729965440752,45.81791998515958,8.382190011351577',
                }),
            },
            {
                label: 'Uri',
                link: buildLink({
                    address: '6482%20Uri%2C%20Schweiz',
                    bounds:
                        '46.99340695836396,8.957809744055153,46.52761403095118,8.39736298884356',
                }),
            },
            {
                label: 'Waadt',
                link: buildLink({
                    address: '1030%20Waadt%2C%20Schweiz',
                    bounds:
                        '46.98690900178253,7.24918485894602,46.18707169270791,6.064009973541158',
                }),
            },
            {
                label: 'Thurgau',
                link: buildLink({
                    address: '8566%20Thurgau%2C%20Schweiz',
                    bounds:
                        '47.69541007080512,9.477632012721717,47.37591506694648,8.667987624051403',
                }),
            },
            {
                label: 'Wallis',
                link: buildLink({
                    address: '3961%20Wallis%2C%20Schweiz',
                    bounds:
                        '46.65404704396803,8.478518562834827,45.8582700228643,6.770459953987134',
                }),
            },
            {
                label: 'Zug',
                link: buildLink({
                    address: '6300%20Zug%2C%20Schweiz',
                    bounds:
                        '47.1898467019641,8.577601425614112,47.08103034921042,8.473837316038924',
                }),
            },
            {
                label: 'Zürich',
                link: buildLink({
                    address: '8001%20Zürich%2C%20Schweiz',
                    bounds:
                        '47.43466497109218,8.625452857661037,47.32021840892072,8.448018098135877',
                }),
            },
        ],
    };

    const de_config = {
        primary: [
            {
                label: 'Baden-Württemberg',
                backgroundUrl:
                    'https://horsedeal.imgix.net/static/landingPage/baden-wuerttemberg.webp',
                link: buildLink({
                    address: 'Baden-Württemberg%2C%20Deutschland',
                    bounds:
                        '49.79132776122719,10.49557302434462,47.53236641011939,7.511811028668679',
                }),
            },
            {
                label: 'Bayern',
                backgroundUrl: 'https://horsedeal.imgix.net/static/landingPage/bayern.webp',
                link: buildLink({
                    address: 'Bayern%2C%20Deutschland',
                    bounds: '50.5647141714916,13.83963709150375,47.27011146235569,8.97634974973039',
                }),
            },
            {
                label: 'Nordrhein-Westfalen',
                backgroundUrl:
                    'https://horsedeal.imgix.net/static/landingPage/nordrhein-westfalen.webp',
                link: buildLink({
                    address: 'Nordrhein-Westfalen%2C%20Deutschland',
                    bounds:
                        '52.53146960292953,9.461634867635038,50.32270096014792,5.86634248758437',
                }),
            },
        ],
        secondary: [
            {
                label: 'Baden-Württemberg',
                link: buildLink({
                    address: 'Baden-Württemberg%2C%20Deutschland',
                    bounds:
                        '49.79132776122719,10.49557302434462,47.53236641011939,7.511811028668679',
                }),
            },
            {
                label: 'Bayern',
                link: buildLink({
                    address: 'Bayern%2C%20Deutschland',
                    bounds: '50.5647141714916,13.83963709150375,47.27011146235569,8.97634974973039',
                }),
            },
            {
                label: 'Berlin',
                link: buildLink({
                    address: 'Berlin%2C%20Deutschland',
                    bounds:
                        '52.67545420869131,13.76111748460941,52.33823404386677,13.08834600183454',
                }),
            },
            {
                label: 'Brandenburg',
                link: buildLink({
                    address: 'Brandenburg%2C%20Deutschland',
                    bounds:
                        '53.55898001390607,14.76582598389879,51.35905856101643,11.26572704896301',
                }),
            },
            {
                label: 'Bremen',
                link: buildLink({
                    address: 'Bremen%2C%20Deutschland',
                    bounds:
                        '53.22891053810295,8.990813130872427,53.01115233044202,8.481758497875816',
                }),
            },
            {
                label: 'Thüringen',
                link: buildLink({
                    address: 'Thüringen%2C%20Deutschland',
                    bounds:
                        '51.64893592927908,12.65393258830968,50.20434665286179,9.876983950481993',
                }),
            },
            {
                label: 'Hamburg',
                link: buildLink({
                    address: 'Hamburg%2C%20Deutschland',
                    bounds: '53.717145,10.123492,53.399999,9.732151000000002',
                }),
            },
            {
                label: 'Hessen',
                link: buildLink({
                    address: 'Hessen%2C%20Deutschland',
                    bounds:
                        '51.65780130784088,10.23632073546354,49.39526111994096,7.772467466570214',
                }),
            },
            {
                label: 'Mecklenburg-Vorpommern',
                link: buildLink({
                    address: 'Mecklenburg-Vorpommern%2C%20Deutschland',
                    bounds:
                        '54.68470053161631,14.41225692140076,53.11031971170281,10.59361375864411',
                }),
            },
            {
                label: 'Niedersachsen',
                link: buildLink({
                    address: 'Niedersachsen%2C%20Deutschland',
                    bounds:
                        '53.89228413379191,11.59820562117043,51.29506736693214,6.653878921909658',
                }),
            },
            {
                label: 'Nordrhein-Westfalen',
                link: buildLink({
                    address: 'Nordrhein-Westfalen%2C%20Deutschland',
                    bounds:
                        '52.53146960292953,9.461634867635038,50.32270096014792,5.86634248758437',
                }),
            },
            {
                label: 'Rheinland-Pfalz',
                link: buildLink({
                    address: 'Rheinland-Pfalz%2C%20Deutschland',
                    bounds:
                        '50.94230527845132,8.508313529098958,48.96675504382872,6.112339987135285',
                }),
            },
            {
                label: 'Saarland',
                link: buildLink({
                    address: 'Saarland%2C%2066%2C%20Deutschland',
                    bounds:
                        '49.63940877357526,7.404583839779054,49.11194290068924,6.356000059019204',
                }),
            },
            {
                label: 'Sachsen',
                link: buildLink({
                    address: 'Sachsen%2C%20Deutschland',
                    bounds:
                        '51.68487102200081,15.04189619759281,50.17137285662097,11.87143577678723',
                }),
            },
            {
                label: 'Sachsen-Anhalt',
                link: buildLink({
                    address: 'Sachsen-Anhalt%2C%20Deutschland',
                    bounds:
                        '53.04178699761326,13.18698749564115,50.93787823229575,10.56083899775602',
                }),
            },
            {
                label: 'Schleswig-Holstein',
                link: buildLink({
                    address: 'Schleswig-Holstein%2C%20Deutschland',
                    bounds:
                        '55.05834696185603,11.31292068737083,53.35980654677694,7.864961321998781',
                }),
            },
        ],
    };

    const defaultCountry = 'CH';

    const countryConfig = {
        CH: ch_config,
        DE: de_config,
    };

    return countryConfig[country] || countryConfig[defaultCountry];
};
